"use client";
import "./contact.css";

import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Alert } from "@mui/material";
import axios from "axios";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    cellNumber: "",
    whatsUp: "sold",
    message: "",
  });
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mailStatus, setMailStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    if (!recaptchaValue) {
      setRecaptchaError(true);
      setLoading(false);

      return;
    }

    try {
      const response = await axios.post(
        `${process.env.NEXT_PUBLIC_ADMIN_API_URL}/contact`,
        {
          ...formData,
          recaptchaValue,
        }
      );

      setLoading(false);

      if (response.status !== 200) {
        setMailStatus("error");

        return;
      }

      setMailStatus("success");
      // Reset form and captcha after submission
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        cellNumber: "",
        whatsUp: "",
        message: "",
      });

      setRecaptchaValue(null);
      setRecaptchaError(false);

      // Reset mail status after 5 seconds
      setTimeout(() => {
        setMailStatus(null);
      }, 5000);
    } catch (error) {
      setLoading(false);
      setMailStatus("error");
      setTimeout(() => {
        setMailStatus(null);
      }, 5000);
    }
  };

  const handleRecaptcha = (value) => {
    setRecaptchaValue(value);
  };

  const recaptchaRef = React.createRef();

  return (
    <section className="section-bg">
      {mailStatus === "success" && (
        <Alert severity="success">
          Thank you for contacting us, we will get back to you soon
        </Alert>
      )}
      {mailStatus === "error" && (
        <Alert severity="error">
          Whoops!!! There was an error sending the email, please try again.
        </Alert>
      )}
      <div className="contactUs-cont">
        <p>
          We can't wait to hear from you. Drop your info below and we'll give
          you a shout.
        </p>
        <div className="contact-flex">
          <div>
            <form onSubmit={handleSubmit}>
              <div className="form-item">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-item">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-item">
                <label>What's up?</label>
                <select
                  name="whatsUp"
                  id="whatsUp"
                  value={formData.whatsUp}
                  onChange={handleChange}
                >
                  <option value="sold">That's it! I'm sold, sign me up!</option>
                  <option value="membership-start">
                    When can I start using my membership?
                  </option>
                  <option value="money-help">
                    I am trying to give you money. Help!
                  </option>
                  <option value="change-debit">
                    Hey, guys, need to change my debit order.
                  </option>
                  <option value="login-battle">
                    Yikes! I'm battling to log in.
                  </option>
                  <option value="booking-battle">
                    Yike! I'm battling to make a booking.
                  </option>
                  <option value="claim-battle">
                    Yikes! (Getting old now) I'm battling to submit a claim.
                  </option>
                  <option value="app-help">
                    Android and Apple malfunctioning. Need help with the OBHC
                    PLUS app.
                  </option>
                  <option value="other">
                    My problem didn't make it onto your list.
                  </option>
                </select>
              </div>
              <div className="form-item">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-item">
                <label>Cell Number</label>
                <input
                  type="tel"
                  name="cellNumber"
                  value={formData.cellNumber}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-item">
                <label>Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                onChange={handleRecaptcha}
                className="recaptcha"
              />
              {recaptchaError && (
                <p style={{ color: "red" }}>Please complete the reCAPTCHA.</p>
              )}
              <button
                style={{ boxShadow: "3px 3px 9px black" }}
                disabled={!recaptchaValue || loading}
                className={`btn ${
                  !recaptchaValue || loading ? "disabled" : ""
                }`}
                type="submit"
              >
                {loading ? "Sending..." : "Submit Query"}
              </button>
            </form>
          </div>
          <div>
            <span>Contact an OFF BEAT PLUS assistant</span>
            <br />
            <p>
              <a href="tel:0822064413" target="_blank">
                082 206 4413
              </a>
              <br />
              <a href="mailto:info@offbeatplus.co.za" target="_blank">
                info@offbeatplus.co.za
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
